module.exports = __webpack_public_path__ + "img/kachel-ERSCHOEPFUNG_VITAAKTIV.4f1d8981.png";